import { InputAdornment, TextField, TextFieldProps } from "@material-ui/core";
import React, {useRef, useEffect, ReactNode} from "react";
import * as masks from "../masks";
import * as parsers from "../unmask";

export type MaskType = 'currency'|'cpf'|'cep'|'percentage';


export type InputMaskProps = Omit<TextFieldProps, "onChange">  & {
    error?:boolean
    mask:MaskType,
    onChange?: (value: any)=>void,
    prefix?: string,
    postfix?: string | ReactNode
    label?: string
};


export const InputMask = (props:InputMaskProps)=>{

    
    const applyMask = function(value:any,previousValue?:any){
        return masks[props.mask](value,previousValue);
    }
    
    const removeMask = (value)=>{
        return value.replace(/[\.\-\/\,]/g,"");
    }
    
    const handleChange = function(e){
        const parser =  parsers[props.mask];
        const maskedValue = applyMask(e.target.value,e.target.defaultValue)
        const parsedValue = parser ? parser(maskedValue) : removeMask(maskedValue);        
        e.target.value = parsedValue
        props.onChange?.(e);

    }

    return <TextField {...props as any}  
            error={props.error||false}
            type="text" 
            helperText={props.helperText}
            value={applyMask(props.value)}
            InputProps={{
                startAdornment: props.prefix && <InputAdornment position="start">{props.prefix}</InputAdornment>,
                endAdornment: props.postfix && <InputAdornment position="end">{props.postfix}</InputAdornment>,
            }}
            onChange={handleChange}
            label={props.label} ></TextField>
}
